import { CakeIcon } from './CakeIcon';

/**
 * author: Google
 * id E5BFDCE4-1033-4062-9677-94B95E028B6E
 * name cake
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cake.svg
 * tags
 * - Holiday 
 * - Food / Drink 
 */
export const BirthdayCakeIcon = CakeIcon;
export default BirthdayCakeIcon